export const WEBENGAGE_EVENTS = {
    Auth: {
        OTP_REQUESTED: "auth.otp_requested",
        OTP_VERIFIED: "auth.otp_verified",
        SIGNUP_SUCCESS: "auth.signup_success",
        LOGIN_SUCCESS: "auth.login_success",
        AUTH_SUCCESS: "auth.auth_success",
    },
    Test: {
        ATTEMPTED: "test.test_attempted",
        CREATED: "test.test_created",
        BEGIN: "test.test_began",
        FINISH: "test.test_finish",
        REPORT_VIEWED: "test.report_viewed",
        SOLUTION_VIEWED: "test.solutions_viewed",
    },
    Profile: {
        UPDATE: "profile.profile_update",
    },
    Program: {
        CHECKOUT_STARTED: "program_checkout_started",
        PAYMENT_INITIATED: "program_payment_initiated",
        PAYMENT_SUCCESS: "program_payment_success",
        PAYMENT_FAILED: "program_payment_failed",
        CARD_CLICKED: "program_card_clicked",
        DETAILS_VIEWED: "program_details_viewed",
    },
    LiveClass: {
        OFFER_VIEWED: "live_class_offer_viewed",
        OFFER_CLICKED: "live_class_offer_clicked",
    },
    Assessment: {
        STARTED: "assessment_started",
        COMPLETED: "assessment_completed",
    },
};
export const BRIDGE_COURSE_WEBENGAGE = {
    CLASS_ELAPSED_MINUTES: "35",
    PLACEMENT_BANNER: "Banner",
    PLACEMENT_ZOOM: "zoom",
    PLACEMENT_OVERLAY: "live_class_overlay",
    PLACEMENT_COURSE_OVERVIEW: "course_overview",
    CTA_ENROLL_NOW: "enroll_now",
};
